<template>
    <div :class="{ 'text-end my-2': !tailwind, 'tw:text-end tw:my-2': tailwind }">
        <div
            :class="{
                'btn btn-primary rounded-0 cursor-pointer': !tailwind,
                'tw:text-base tw:bg-(--shop-primary) tw:inline-block tw:rounded-0 tw:px-4 tw:py-2 tw:cursor-pointer tw:rounded-4xl tw:text-white': tailwind,
                'tw:opacity-50 tw:cursor-not-allowed': disabled,
            }"
            @click="clickHandler"
        >
            <span v-html="label"></span>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    tailwind: {
        type: Boolean,
        default: false,
    },
    onClick: {
        type: Function,
        default: null,
    },
    label: {
        type: String,
        default: window.TABS.$t("Gå videre"),
    },
    disabled: {
        type: Boolean,
        default: false,
    }
});

const clickHandler = () => {
    if (props.disabled) {
        return;
    }
    if (props.onClick && typeof props.onClick === 'function') {
        props.onClick();
    }
};
</script>
